// eslint-disable-next-line no-use-before-define
import { useMutation, useQuery } from '@apollo/client';
import React from 'react';
import { generatePath } from 'react-router';
import { useParams } from 'react-router-dom';
import { FormProps } from '../interfaces';
import AddressForm from './AddressForm';
import { REGISTRATION_ADDRESS_QUERY, UPDATE_REGISTRATION_POSTAL_ADDRESS } from './AddressQueries';

const Address = (props: FormProps): JSX.Element => {
  const { patientId } = useParams<{ patientId: string }>();
  const { exitForm } = props;
  const [updateSamePostalAddress] = useMutation(UPDATE_REGISTRATION_POSTAL_ADDRESS);
  const { data, error } = useQuery(REGISTRATION_ADDRESS_QUERY, {
    variables: { id: patientId },
  });

  const { patient, user } = data || {};

  if (error || !data) return <></>;

  const updateField = (field: string, value: string | boolean | number) => {
    updateSamePostalAddress({
      variables: {
        id: patientId,
        [field]: value,
      },
    });
  };

  return (
    <AddressForm
      updateField={updateField}
      patient={patient}
      handleShowSaveExitConfirm={() => exitForm(true)}
      previousPageLink={generatePath(`/patient/${patient.id}/registration/contact`)}
      isPso={user.isPso}
    />
  );
};

export default Address;
